import { useCommon } from "../composition-functions/common";
import { RatePlanMappingDto, RatePlanMappingInputDto } from "./dto.ratePlanMapping";

export async function getRatePlanMappings(mandantId: number): Promise<RatePlanMappingDto[]> {
  const { getRequest } = useCommon();
  const response = await getRequest({ path: `/admin/mandants/${mandantId}/smartpricing/ratePlanMapping` });
  return await response.json();
}

interface SetRatePlanMappingsParams {
  mandantId: number;
  ratePlanMappingInputDtos: RatePlanMappingInputDto[];
}
export async function setRatePlanMappings({
  mandantId,
  ratePlanMappingInputDtos,
}: SetRatePlanMappingsParams): Promise<RatePlanMappingDto[]> {
  const { postRequest } = useCommon();
  const response = await postRequest({
    path: `/admin/mandants/${mandantId}/smartpricing/ratePlanMapping`,
    data: JSON.stringify(ratePlanMappingInputDtos),
  });
  return await response.json();
}
